export const title = 'Expense Code';

export const add_expense_code_button = 'Add Expense Code';
export const add_expense_code_form_header = 'Add an Expense Code';
export const add_expense_code_form_textfield = 'Expense Code*';
export const add_expense_code_form_button_one = 'Save and add another';
export const add_expense_code_form_button_two = 'Save';

export const edit_expense_code_button = 'Edit';
export const edit_expense_code_form_header = 'Edit an Expense Code';
export const edit_expense_code_form_button = 'Save';

export const delete_expense_code_button = 'Delete';
export const delete_expense_code_dialog_button_one = 'Back to Expense Codes';
export const delete_expense_code_dialog_button_two = 'Delete';
export const delete_expense_code_dialog_title = 'Delete';
export const delete_expense_code_dialog_subtitle =
  'Deleting this expense code might affect the allowances linked to it. Delete anyway?';

export const expense_code_table_header_one = 'Code ID';
export const expense_code_table_header_two = 'Expense Code';

export const search_expense_code_text = 'Search for Expense Code';

export const expense_code_empty_cta_title =
  'Keep track of the company’s expenses by using expense codes';
export const expense_code_empty_cta_subtitle =
  'Create expense codes and tag it to employees';

export enum Actions {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete'
}
